import React from "react";

function LocationPinIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				fill="#8C8594"
				d="M12 2C7.577 2 4 5.215 4 9.19c0 4.284 5.051 10.19 7.131 12.44.458.493 1.292.493 1.749 0C14.949 19.38 20 13.474 20 9.19 20 5.216 16.423 2 12 2zm0 9.759c-1.577 0-2.857-1.15-2.857-2.568 0-1.418 1.28-2.569 2.857-2.569 1.577 0 2.857 1.151 2.857 2.569 0 1.417-1.28 2.568-2.857 2.568z"
			/>
		</svg>
	);
}

export default LocationPinIcon;
